var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionBack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 11H7.50001L13.1 5.4L11.7 4L3.70001 12L11.7 20L13.1 18.6L7.50001 13H20V11Z",
    fill: "#237BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionBack);
export default __webpack_public_path__ + "static/media/ic_action_back.c826becced33f949eeeefccf598c54bb.svg";
export { ForwardRef as ReactComponent };